/**
 * 配置不需要進行codeflow的頁面路由
 */
/* 不需要登陆路由 */
const noSigns = ['/demo', '/faceauthb'];

export default () => noSigns.some(item => window.location.href.indexOf(item) !== -1);
